export default {
  pt: {
    'form.permissionPicker.search': "Buscar permissão",
    'form.permissionPicker.selectAll': "Marcar todas",
    'form.permissionPicker.clearAll': "Desmarcar todas",
    'form.permissionPicker.noResults': "Nenhuma permissão encontrada.",
    'form.permissionPicker.expand': "Expandir {{module}}",
    'form.permissionPicker.collapse': "Recolher {{module}}",
    'form.permissionPicker.totalSelected': "Selecionadas {{count}} de {{total}}",
    'permissions.module.mensagem_teclado': "Mensagens Teclado",
    'permissions.item.mensagem_teclado.view': "Ver mensagens do teclado",
    'permissions.item.mensagem_teclado.conferir': "Conferir mensagem",
    'permissions.module.abastecimento': "Solicitação de abastecimento",
    'permissions.item.abastecimento.view': "Ver solicitações",
    'permissions.item.abastecimento.create': "Gerar solicitação",
    'permissions.item.abastecimento.delete': "Excluir solicitação",
    'permissions.item.abastecimento.tratar_alerta': 'Tratar alerta de abastecimento',
    'permissions.module.lodging': "Hospedagem",
    'permissions.item.lodging.view': "Ver hospedagens",
    'permissions.item.lodging.create': "Criar registro de hospedagem",
    'permissions.item.lodging.edit': "Editar registro e ocupantes",
    'permissions.item.lodging.checkout': "Registrar check-out",
    'permissions.item.lodging.finalize': "Finalizar registro",
    'permissions.item.lodging.delete': "Excluir quarto contratado",
    'permissions.item.lodging.hotel_config': "Editar configurações de hospedagem do hotel",
    'form.permissionPicker.adminFullAccess': 'Administrador da equipe tem acesso total a todas as áreas do sistema.',
    'form.permissionPicker.loading': 'Carregando permissões…',
    'form.permissionPicker.loadFailed': 'Não foi possível carregar as permissões. Recarregue a página.',
    'form.permissionPicker.doCargo': 'Do cargo',
    'form.permissionPicker.semArea': 'Marque a área {{areas}} para conceder estas permissões.',
    'form.permissionPicker.ouAreas': ' ou ',
    'form.areaPicker.legenda': 'Áreas',
    'form.areaPicker.ajudaCargo': 'Todo usuário deste cargo entra nestas áreas. A área sozinha não abre nenhuma tela: cada módulo segue pedindo a própria permissão.',
    'form.areaPicker.ajudaUsuario': 'As áreas do cargo vêm marcadas e travadas. Marque aqui só as que este usuário recebe além do cargo.',
    'form.areaPicker.doCargo': 'Do cargo',
    'form.areaPicker.adminTodas': 'Administrador da equipe entra em todas as áreas.',
    'permissions.module.dashboard': 'Dashboard',
    'permissions.module.pendencias': 'Pendências',
    'permissions.module.map': 'Mapa',
    'permissions.module.frota_leve_anomalias': 'Anomalia Frota',
    'permissions.module.contracts': 'Contratos',
    'permissions.module.unloading': 'Painel de Descarga',
    'permissions.module.shipments': 'Frente de Trabalho',
    'permissions.module.machine_transport': 'Transporte Máquina',
    'permissions.module.outros_servicos_transporte': 'Outros Serviços Transporte',
    'permissions.module.sets': 'Conjuntos',
    'permissions.module.master_data': 'Cadastros',
    'permissions.module.imports': 'Importação em massa',
    'permissions.module.dp_ponto': 'Assinatura do ponto',
    'permissions.item.dp_ponto.view': 'Ver assinaturas do ponto',
    'permissions.item.dp_ponto.edit': 'Importar, marcar e cobrar assinaturas',
    'permissions.item.dp_ponto.fechar': 'Fechar e reabrir a competência',
    'permissions.module.dp_vale_alimentacao': 'Vale-alimentação',
    'permissions.item.dp_vale_alimentacao.view': 'Ver o vale-alimentação',
    'permissions.item.dp_vale_alimentacao.edit': 'Apurar e ajustar o vale-alimentação',
    'permissions.item.dp_vale_alimentacao.fechar': 'Fechar e reabrir a competência',
    'permissions.module.dp_ferias': 'Férias',
    'permissions.item.dp_ferias.view': 'Ver férias e programações',
    'permissions.item.dp_ferias.edit': 'Importar a programação e registrar tratativas',
    'permissions.module.dp_desligamento': 'Desligamentos',
    'permissions.item.dp_desligamento.view': 'Ver desligamentos',
    'permissions.item.dp_desligamento.edit': 'Abrir e conduzir desligamentos',
    'permissions.module.dp_plano_saude': 'Plano de saúde',
    'permissions.item.dp_plano_saude.view': 'Ver a fatura do plano de saúde',
    'permissions.item.dp_plano_saude.edit': 'Importar a fatura e conferir titulares',
    'permissions.module.dp_exame': 'Exames',
    'permissions.item.dp_exame.view': 'Ver convocações de exame',
    'permissions.item.dp_exame.edit': 'Importar, agendar e registrar exames',
    'permissions.module.dp_cnh': 'CNH',
    'permissions.item.dp_cnh.view': 'Ver vencimentos de CNH',
    'permissions.item.dp_cnh.edit': 'Atualizar vencimento e cobrar CNH',
    'permissions.module.dp_toxicologico': 'Toxicológico',
    'permissions.item.dp_toxicologico.view': 'Ver exames toxicológicos',
    'permissions.item.dp_toxicologico.edit': 'Registrar exames toxicológicos e anexar o relatório',
    'permissions.module.dp_bonus': 'Bônus e adicionais',
    'permissions.item.dp_bonus.view': 'Ver bônus e adicionais',
    'permissions.item.dp_bonus.edit': 'Apurar bônus e manter a tabela de valores',
    'permissions.item.dp_bonus.fechar': 'Fechar e reabrir a competência',
    'permissions.module.dp_contratacao': 'Contratações',
    'permissions.item.dp_contratacao.view': 'Ver vagas em aberto',
    'permissions.item.dp_contratacao.edit': 'Abrir e conduzir vagas',
    'permissions.module.dp_rotina': 'Rotinas da folha',
    'permissions.item.dp_rotina.view': 'Ver rotinas e checklist da folha',
    'permissions.item.dp_rotina.edit': 'Marcar rotinas e conferências',
    'permissions.module.dp_multa': 'Multas',
    'permissions.item.dp_multa.view': 'Ver as multas lançadas pelo Abastecimento',
    'permissions.module.multa': 'Multas',
    'permissions.item.multa.view': 'Ver multas',
    'permissions.item.multa.create': 'Lançar multa',
    'permissions.item.multa.edit': 'Editar multa e anexos',
    'permissions.item.multa.cancel': 'Cancelar multa',
    // HubVerticalFarm (02/11/2026): um módulo por item do menu da Farm.
    'permissions.module.farm_inicio': 'Início da Farm',
    'permissions.item.farm_inicio.view': 'Ver início da Farm',
    'permissions.module.farm_mapa': 'Mapa das fazendas',
    'permissions.item.farm_mapa.view': 'Ver mapa das fazendas',
    'permissions.item.farm_mapa.manage': 'Gerir mapa das fazendas',
    'permissions.module.farm_agenda': 'Agenda das fazendas',
    'permissions.item.farm_agenda.view': 'Ver agenda das fazendas',
    'permissions.item.farm_agenda.manage': 'Gerir agenda das fazendas',
    'permissions.item.farm_agenda.pessoal': 'Ver e lançar as obrigações pessoais',
    'permissions.module.farm_imoveis': 'Imóveis',
    'permissions.item.farm_imoveis.view': 'Ver imóveis',
    'permissions.item.farm_imoveis.manage': 'Gerir imóveis',
    'permissions.module.farm_documentos': 'Documentos das fazendas',
    'permissions.item.farm_documentos.view': 'Ver documentos das fazendas',
    'permissions.item.farm_documentos.manage': 'Gerir documentos das fazendas',
    'permissions.item.farm_documentos.historico': 'Apagar versão antiga de documento',
    'permissions.module.farm_fundo': 'Fundo e arrendamentos',
    'permissions.item.farm_fundo.view': 'Ver fundo e arrendamentos',
    'permissions.item.farm_fundo.manage': 'Gerir fundo e arrendamentos',
    'permissions.module.farm_lavoura': 'Lavoura',
    'permissions.item.farm_lavoura.view': 'Ver lavoura',
    'permissions.item.farm_lavoura.manage': 'Gerir lavoura',
    'permissions.module.farm_confinamento': 'Confinamento',
    'permissions.item.farm_confinamento.view': 'Ver confinamento',
    'permissions.item.farm_confinamento.manage': 'Gerir confinamento',
    'permissions.module.farm_floresta': 'Floresta e carvão',
    'permissions.item.farm_floresta.view': 'Ver floresta e carvão',
    'permissions.item.farm_floresta.manage': 'Gerir floresta e carvão',
    'permissions.module.farm_equipe': 'Equipe das fazendas',
    'permissions.item.farm_equipe.view': 'Ver equipe das fazendas',
    'permissions.item.farm_equipe.manage': 'Vincular pessoa ao imóvel',
    'permissions.module.farm_financeiro': 'Faturamento e custos',
    'permissions.item.farm_financeiro.view': 'Ver faturamento e custos',
    'permissions.item.farm_financeiro.importar': 'Enviar os arquivos do Protheus',
    'permissions.module.farm_parceiros': 'Parceiros',
    'permissions.item.farm_parceiros.view': 'Ver parceiros',
    'permissions.item.farm_parceiros.manage': 'Gerir parceiros',
    'permissions.module.farm_safras': 'Safras e culturas',
    'permissions.item.farm_safras.view': 'Ver safras e culturas',
    'permissions.item.farm_safras.manage': 'Gerir safras e culturas',
    'permissions.module.farm_contatos': 'Contatos das fazendas',
    'permissions.item.farm_contatos.view': 'Ver contatos das fazendas',
    'permissions.item.farm_contatos.manage': 'Gerir contatos das fazendas',
    'permissions.module.dp_ausencia': 'Ausências',
    'permissions.item.dp_ausencia.view': 'Ver ausências, calendário e linha do tempo',
    'permissions.item.dp_ausencia.edit': 'Cadastrar e encerrar ausências',
    'permissions.module.dp_parametro': 'Parâmetros do DP',
    'permissions.item.dp_parametro.view': 'Ver os parâmetros do DP',
    'permissions.item.dp_parametro.edit': 'Alterar os parâmetros do DP',
    'permissions.module.dp_alerta': 'Destinatários de alerta',
    'permissions.item.dp_alerta.view': 'Ver os grupos de destinatários de alerta',
    'permissions.item.dp_alerta.edit': 'Montar os grupos e enviar o e-mail de teste',
    'permissions.module.dp_colaborador': 'Histórico do colaborador',
    'permissions.item.dp_colaborador.view': 'Ver o histórico do colaborador',
    'permissions.module.dp_folha': 'Conferência da folha',
    'permissions.item.dp_folha.view': 'Ver a conferência da folha',
    'permissions.item.dp_folha.edit': 'Importar a folha, rodar as regras e justificar alertas',
    'permissions.item.dp_folha.fechar': 'Fechar e reabrir a conferência',
    'permissions.module.dp_sinistro': 'Sinistros',
    'permissions.item.dp_sinistro.view': 'Ver os sinistros lançados pelo Abastecimento',
    'permissions.module.sinistro': 'Sinistros',
    'permissions.item.sinistro.view': 'Ver sinistros',
    'permissions.item.sinistro.create': 'Lançar sinistro',
    'permissions.item.sinistro.edit': 'Editar sinistro e anexos',
    'permissions.item.sinistro.cancel': 'Cancelar sinistro',
    'permissions.module.dp_sensivel': 'Dado sensível do DP',
    'permissions.item.dp_sensivel.salario': 'Ver salário, valores de rescisão e coparticipação',
    'permissions.module.users': 'Usuários',
    'permissions.module.audit': 'Auditoria',
    'permissions.item.dashboard.view': 'Ver dashboard',
    'permissions.item.pendencias.view': 'Ver pendências',
    'permissions.item.map.view': 'Ver mapa',
    'permissions.item.map.interact': 'Interagir com o mapa',
    'permissions.item.frota_leve_anomalias.view': 'Ver anomalia da frota',
    'permissions.item.contracts.view': 'Ver contratos',
    'permissions.item.contracts.create': 'Criar contrato',
    'permissions.item.contracts.edit': 'Editar contrato',
    'permissions.item.contracts.delete': 'Excluir contrato',
    'permissions.item.contracts.programar': 'Programar cargas',
    'permissions.item.contracts.programacao_ver': 'Ver a programação do cliente',
    'permissions.item.contracts.programacao_gerir': 'Gerir a programação do cliente',
    'permissions.item.unloading.view': 'Ver painel de descarga',
    'permissions.item.unloading.tickets_manage': 'Gerir solicitações',
    'permissions.item.unloading.launch': 'Lançar descarga',
    'permissions.item.unloading.approve': 'Aprovar e transicionar',
    'permissions.item.shipments.view': 'Ver cargas',
    'permissions.item.shipments.create': 'Criar carga',
    'permissions.item.shipments.edit': 'Editar carga',
    'permissions.item.shipments.delete': 'Excluir carga',
    'permissions.item.machine_transport.view': 'Ver',
    'permissions.item.machine_transport.create': 'Criar',
    'permissions.item.machine_transport.edit': 'Editar',
    'permissions.item.machine_transport.delete': 'Excluir',
    'permissions.item.machine_transport.editar_datas': 'Corrigir Início e Fim da prancha',
    'permissions.item.outros_servicos_transporte.view': 'Ver',
    'permissions.item.outros_servicos_transporte.create': 'Criar',
    'permissions.item.outros_servicos_transporte.edit': 'Editar',
    'permissions.item.outros_servicos_transporte.delete': 'Excluir',
    'permissions.module.viagens': 'Viagens',
    'permissions.item.viagens.view': 'Ver viagens',
    'permissions.item.viagens.ajustar': 'Ajustar viagem e apontar serviço',
    'permissions.item.viagens.tratar_alerta': 'Tratar alerta de viagem',
    'permissions.item.viagens.cobranca': 'Marcar cobrança e configurar limite de descarga',
    'permissions.module.pedagios': 'Pedágios',
    'permissions.item.pedagios.view': 'Ver pedágios',
    'permissions.item.pedagios.vincular': 'Vincular passagem à viagem',
    'permissions.module.colheita': 'Colheita',
    'permissions.item.colheita.view': 'Ver colheita',
    'permissions.item.sets.view': 'Ver',
    'permissions.item.sets.create': 'Criar',
    'permissions.item.sets.edit': 'Editar',
    'permissions.item.sets.delete': 'Excluir',
    'permissions.module.journey': 'Painel de Jornada',
    'permissions.item.journey.view': 'Ver painel de jornada',
    'permissions.item.journey.tratar': 'Justificar ou classificar infração como Gestão',
    'permissions.module.diaria': 'Painel de Diárias',
    'permissions.item.diaria.view': 'Ver painel de diárias',
    'permissions.item.diaria.edit': 'Lançar e corrigir diária',
    'permissions.module.advertencia': 'Gestões',
    'permissions.item.advertencia.view': 'Ver gestões',
    'permissions.item.advertencia.gerar': 'Gerar, aplicar e cancelar gestões',
    'permissions.item.master_data.view': 'Ver cadastros',
    'permissions.item.master_data.create': 'Criar cadastro',
    'permissions.item.master_data.edit': 'Editar cadastro',
    'permissions.item.master_data.delete': 'Excluir cadastro',
    'permissions.item.master_data.pii': 'Ver CPF e telefone completos',
    'permissions.item.imports.view': 'Ver histórico e modelos',
    'permissions.item.imports.run': 'Validar e importar',
    'permissions.item.users.view': 'Ver usuários',
    'permissions.item.users.manage': 'Gerir usuários e permissões',
    'permissions.item.audit.view': 'Consultar trilha de auditoria',
    'permissions.item.audit.export': 'Exportar trilha de auditoria',
    'permissions.module.assistente': 'Assistente',
    'permissions.item.assistente.usar': 'Conversar com o assistente',
  },
  en: {
    'form.permissionPicker.search': "Search permission",
    'form.permissionPicker.selectAll': "Select all",
    'form.permissionPicker.clearAll': "Clear all",
    'form.permissionPicker.noResults': "No permission found.",
    'form.permissionPicker.expand': "Expand {{module}}",
    'form.permissionPicker.collapse': "Collapse {{module}}",
    'form.permissionPicker.totalSelected': "Selected {{count}} of {{total}}",
    'permissions.module.mensagem_teclado': "Keyboard messages",
    'permissions.item.mensagem_teclado.view': "View keyboard messages",
    'permissions.item.mensagem_teclado.conferir': "Check message",
    'permissions.module.abastecimento': "Fuel requests",
    'permissions.item.abastecimento.view': "View requests",
    'permissions.item.abastecimento.create': "Create request",
    'permissions.item.abastecimento.delete': "Delete request",
    'permissions.item.abastecimento.tratar_alerta': 'Handle fueling alert',
    'permissions.module.lodging': "Lodging",
    'permissions.item.lodging.view': "View lodgings",
    'permissions.item.lodging.create': "Create lodging record",
    'permissions.item.lodging.edit': "Edit record and occupants",
    'permissions.item.lodging.checkout': "Record check-out",
    'permissions.item.lodging.finalize': "Finalize record",
    'permissions.item.lodging.delete': "Delete contracted room",
    'permissions.item.lodging.hotel_config': "Edit hotel lodging settings",
    'form.permissionPicker.adminFullAccess': 'The team administrator has full access to all areas of the system.',
    'form.permissionPicker.loading': 'Loading permissions…',
    'form.permissionPicker.loadFailed': 'Could not load permissions. Reload the page.',
    'form.permissionPicker.doCargo': 'From position',
    'form.permissionPicker.semArea': 'Select the {{areas}} area to grant these permissions.',
    'form.permissionPicker.ouAreas': ' or ',
    'form.areaPicker.legenda': 'Areas',
    'form.areaPicker.ajudaCargo': 'Every user in this position enters these areas. An area alone opens no screen: each module still requires its own permission.',
    'form.areaPicker.ajudaUsuario': 'The position areas come checked and locked. Check here only the ones this user gets on top of the position.',
    'form.areaPicker.doCargo': 'From position',
    'form.areaPicker.adminTodas': 'The team administrator enters every area.',
    'permissions.module.dashboard': 'Dashboard',
    'permissions.module.pendencias': 'Pending items',
    'permissions.module.map': 'Map',
    'permissions.module.frota_leve_anomalias': 'Fleet anomaly',
    'permissions.module.contracts': 'Contracts',
    'permissions.module.unloading': 'Unloading Panel',
    'permissions.module.shipments': 'Work Front',
    'permissions.module.machine_transport': 'Machine Transport',
    'permissions.module.outros_servicos_transporte': 'Other Transport Services',
    'permissions.module.sets': 'Sets',
    'permissions.module.master_data': 'Master Data',
    'permissions.module.imports': 'Bulk Import',
    'permissions.module.dp_ponto': 'Timesheet signature',
    'permissions.item.dp_ponto.view': 'View timesheet signatures',
    'permissions.item.dp_ponto.edit': 'Import, mark and follow up signatures',
    'permissions.item.dp_ponto.fechar': 'Close and reopen the period',
    'permissions.module.dp_vale_alimentacao': 'Meal allowance',
    'permissions.item.dp_vale_alimentacao.view': 'View the meal allowance',
    'permissions.item.dp_vale_alimentacao.edit': 'Calculate and adjust the meal allowance',
    'permissions.item.dp_vale_alimentacao.fechar': 'Close and reopen the period',
    'permissions.module.dp_ferias': 'Vacations',
    'permissions.item.dp_ferias.view': 'View vacations and schedules',
    'permissions.item.dp_ferias.edit': 'Import the schedule and log follow-ups',
    'permissions.module.dp_desligamento': 'Terminations',
    'permissions.item.dp_desligamento.view': 'View terminations',
    'permissions.item.dp_desligamento.edit': 'Open and run terminations',
    'permissions.module.dp_plano_saude': 'Health plan',
    'permissions.item.dp_plano_saude.view': 'View the health plan invoice',
    'permissions.item.dp_plano_saude.edit': 'Import the invoice and check holders',
    'permissions.module.dp_exame': 'Medical exams',
    'permissions.item.dp_exame.view': 'View exam calls',
    'permissions.item.dp_exame.edit': 'Import, schedule and record exams',
    'permissions.module.dp_cnh': "Driver's license",
    'permissions.item.dp_cnh.view': 'View license expirations',
    'permissions.item.dp_cnh.edit': 'Update expiration and follow up',
    'permissions.module.dp_toxicologico': 'Drug testing',
    'permissions.item.dp_toxicologico.view': 'View drug tests',
    'permissions.item.dp_toxicologico.edit': 'Record drug tests and attach the report',
    'permissions.module.dp_bonus': 'Bonuses and allowances',
    'permissions.item.dp_bonus.view': 'View bonuses and allowances',
    'permissions.item.dp_bonus.edit': 'Calculate bonuses and maintain the rate table',
    'permissions.item.dp_bonus.fechar': 'Close and reopen the period',
    'permissions.module.dp_contratacao': 'Hiring',
    'permissions.item.dp_contratacao.view': 'View open positions',
    'permissions.item.dp_contratacao.edit': 'Open and manage positions',
    'permissions.module.dp_rotina': 'Payroll routines',
    'permissions.item.dp_rotina.view': 'View payroll routines and checklist',
    'permissions.item.dp_rotina.edit': 'Mark routines and checks',
    'permissions.module.dp_multa': 'Traffic fines',
    'permissions.item.dp_multa.view': 'View the fines entered by Fueling',
    'permissions.module.multa': 'Traffic fines',
    'permissions.item.multa.view': 'View fines',
    'permissions.item.multa.create': 'Enter fine',
    'permissions.item.multa.edit': 'Edit fine and attachments',
    'permissions.item.multa.cancel': 'Cancel fine',
    // HubVerticalFarm (02/11/2026): um módulo por item do menu da Farm.
    'permissions.module.farm_inicio': 'Farm home',
    'permissions.item.farm_inicio.view': 'View farm home',
    'permissions.module.farm_mapa': 'Farm map',
    'permissions.item.farm_mapa.view': 'View farm map',
    'permissions.item.farm_mapa.manage': 'Manage farm map',
    'permissions.module.farm_agenda': 'Farm schedule',
    'permissions.item.farm_agenda.view': 'View farm schedule',
    'permissions.item.farm_agenda.manage': 'Manage farm schedule',
    'permissions.item.farm_agenda.pessoal': 'View and add personal obligations',
    'permissions.module.farm_imoveis': 'Properties',
    'permissions.item.farm_imoveis.view': 'View properties',
    'permissions.item.farm_imoveis.manage': 'Manage properties',
    'permissions.module.farm_documentos': 'Farm documents',
    'permissions.item.farm_documentos.view': 'View farm documents',
    'permissions.item.farm_documentos.manage': 'Manage farm documents',
    'permissions.item.farm_documentos.historico': 'Delete an old document version',
    'permissions.module.farm_fundo': 'Fund and leases',
    'permissions.item.farm_fundo.view': 'View fund and leases',
    'permissions.item.farm_fundo.manage': 'Manage fund and leases',
    'permissions.module.farm_lavoura': 'Crops',
    'permissions.item.farm_lavoura.view': 'View crops',
    'permissions.item.farm_lavoura.manage': 'Manage crops',
    'permissions.module.farm_confinamento': 'Feedlot',
    'permissions.item.farm_confinamento.view': 'View feedlot',
    'permissions.item.farm_confinamento.manage': 'Manage feedlot',
    'permissions.module.farm_floresta': 'Forestry and charcoal',
    'permissions.item.farm_floresta.view': 'View forestry and charcoal',
    'permissions.item.farm_floresta.manage': 'Manage forestry and charcoal',
    'permissions.module.farm_equipe': 'Farm team',
    'permissions.item.farm_equipe.view': 'View farm team',
    'permissions.item.farm_equipe.manage': 'Link a person to a property',
    'permissions.module.farm_financeiro': 'Revenue and costs',
    'permissions.item.farm_financeiro.view': 'View revenue and costs',
    'permissions.item.farm_financeiro.importar': 'Upload the Protheus files',
    'permissions.module.farm_parceiros': 'Partners',
    'permissions.item.farm_parceiros.view': 'View partners',
    'permissions.item.farm_parceiros.manage': 'Manage partners',
    'permissions.module.farm_safras': 'Seasons and crops',
    'permissions.item.farm_safras.view': 'View seasons and crops',
    'permissions.item.farm_safras.manage': 'Manage seasons and crops',
    'permissions.module.farm_contatos': 'Farm contacts',
    'permissions.item.farm_contatos.view': 'View farm contacts',
    'permissions.item.farm_contatos.manage': 'Manage farm contacts',
    'permissions.module.dp_ausencia': 'Absences',
    'permissions.item.dp_ausencia.view': 'View absences, calendar and timeline',
    'permissions.item.dp_ausencia.edit': 'Register and close absences',
    'permissions.module.dp_parametro': 'HR parameters',
    'permissions.item.dp_parametro.view': 'View HR parameters',
    'permissions.item.dp_parametro.edit': 'Change HR parameters',
    'permissions.module.dp_alerta': 'Alert recipients',
    'permissions.item.dp_alerta.view': 'View the alert recipient groups',
    'permissions.item.dp_alerta.edit': 'Build the groups and send the test e-mail',
    'permissions.module.dp_colaborador': 'Employee history',
    'permissions.item.dp_colaborador.view': 'View employee history',
    'permissions.module.dp_folha': 'Payroll check',
    'permissions.item.dp_folha.view': 'View the payroll check',
    'permissions.item.dp_folha.edit': 'Import the payroll, run the rules and justify alerts',
    'permissions.item.dp_folha.fechar': 'Close and reopen the check',
    'permissions.module.dp_sinistro': 'Claims',
    'permissions.item.dp_sinistro.view': 'View the claims entered by Fueling',
    'permissions.module.sinistro': 'Claims',
    'permissions.item.sinistro.view': 'View claims',
    'permissions.item.sinistro.create': 'Enter claim',
    'permissions.item.sinistro.edit': 'Edit claim and attachments',
    'permissions.item.sinistro.cancel': 'Cancel claim',
    'permissions.module.dp_sensivel': 'Sensitive HR data',
    'permissions.item.dp_sensivel.salario': 'View salary, termination amounts and copayment',
    'permissions.module.users': 'Users',
    'permissions.module.audit': 'Audit',
    'permissions.item.dashboard.view': 'View dashboard',
    'permissions.item.pendencias.view': 'View pending items',
    'permissions.item.map.view': 'View map',
    'permissions.item.map.interact': 'Interact with the map',
    'permissions.item.frota_leve_anomalias.view': 'View fleet anomaly',
    'permissions.item.contracts.view': 'View contracts',
    'permissions.item.contracts.create': 'Create contract',
    'permissions.item.contracts.edit': 'Edit contract',
    'permissions.item.contracts.delete': 'Delete contract',
    'permissions.item.contracts.programar': 'Schedule loads',
    'permissions.item.contracts.programacao_ver': 'View the customer schedule',
    'permissions.item.contracts.programacao_gerir': 'Manage the customer schedule',
    'permissions.item.unloading.view': 'View unloading panel',
    'permissions.item.unloading.tickets_manage': 'Manage requests',
    'permissions.item.unloading.launch': 'Record unloading',
    'permissions.item.unloading.approve': 'Approve and transition',
    'permissions.item.shipments.view': 'View loads',
    'permissions.item.shipments.create': 'Create load',
    'permissions.item.shipments.edit': 'Edit load',
    'permissions.item.shipments.delete': 'Delete load',
    'permissions.item.machine_transport.view': 'View',
    'permissions.item.machine_transport.create': 'Create',
    'permissions.item.machine_transport.edit': 'Edit',
    'permissions.item.machine_transport.delete': 'Delete',
    'permissions.item.machine_transport.editar_datas': 'Correct flatbed start and end dates',
    'permissions.item.outros_servicos_transporte.view': 'View',
    'permissions.item.outros_servicos_transporte.create': 'Create',
    'permissions.item.outros_servicos_transporte.edit': 'Edit',
    'permissions.item.outros_servicos_transporte.delete': 'Delete',
    'permissions.module.viagens': 'Trips',
    'permissions.item.viagens.view': 'View trips',
    'permissions.item.viagens.ajustar': 'Adjust trip and assign service',
    'permissions.item.viagens.tratar_alerta': 'Handle trip alert',
    'permissions.item.viagens.cobranca': 'Mark billing and set the unloading limit',
    'permissions.module.pedagios': 'Tolls',
    'permissions.item.pedagios.view': 'View tolls',
    'permissions.item.pedagios.vincular': 'Link a toll passage to a trip',
    'permissions.module.colheita': 'Harvest',
    'permissions.item.colheita.view': 'View harvest',
    'permissions.item.sets.view': 'View',
    'permissions.item.sets.create': 'Create',
    'permissions.item.sets.edit': 'Edit',
    'permissions.item.sets.delete': 'Delete',
    'permissions.module.journey': 'Journey Panel',
    'permissions.item.journey.view': 'View journey panel',
    'permissions.item.journey.tratar': 'Justify or classify an infraction as a measure',
    'permissions.module.diaria': 'Daily Allowances',
    'permissions.item.diaria.view': 'View daily allowances panel',
    'permissions.item.diaria.edit': 'Enter and correct allowances',
    'permissions.module.advertencia': 'Measures',
    'permissions.item.advertencia.view': 'View measures',
    'permissions.item.advertencia.gerar': 'Create, apply and cancel measures',
    'permissions.item.master_data.view': 'View master data',
    'permissions.item.master_data.create': 'Create record',
    'permissions.item.master_data.edit': 'Edit record',
    'permissions.item.master_data.delete': 'Delete record',
    'permissions.item.master_data.pii': 'View full national ID and phone',
    'permissions.item.imports.view': 'View history and templates',
    'permissions.item.imports.run': 'Validate and import',
    'permissions.item.users.view': 'View users',
    'permissions.item.users.manage': 'Manage users and permissions',
    'permissions.item.audit.view': 'View audit trail',
    'permissions.item.audit.export': 'Export audit trail',
    'permissions.module.assistente': 'Assistant',
    'permissions.item.assistente.usar': 'Chat with the assistant',
  },
  es: {
    'form.permissionPicker.search': "Buscar permiso",
    'form.permissionPicker.selectAll': "Marcar todas",
    'form.permissionPicker.clearAll': "Desmarcar todas",
    'form.permissionPicker.noResults': "Ningún permiso encontrado.",
    'form.permissionPicker.expand': "Expandir {{module}}",
    'form.permissionPicker.collapse': "Contraer {{module}}",
    'form.permissionPicker.totalSelected': "Seleccionados {{count}} de {{total}}",
    'permissions.module.mensagem_teclado': "Mensajes de teclado",
    'permissions.item.mensagem_teclado.view': "Ver mensajes de teclado",
    'permissions.item.mensagem_teclado.conferir': "Revisar mensaje",
    'permissions.module.abastecimento': "Solicitud de abastecimiento",
    'permissions.item.abastecimento.view': "Ver solicitudes",
    'permissions.item.abastecimento.create': "Generar solicitud",
    'permissions.item.abastecimento.delete': "Eliminar solicitud",
    'permissions.item.abastecimento.tratar_alerta': 'Tratar alerta de abastecimiento',
    'permissions.module.lodging': "Hospedaje",
    'permissions.item.lodging.view': "Ver hospedajes",
    'permissions.item.lodging.create': "Crear registro de hospedaje",
    'permissions.item.lodging.edit': "Editar registro y ocupantes",
    'permissions.item.lodging.checkout': "Registrar check-out",
    'permissions.item.lodging.finalize': "Finalizar registro",
    'permissions.item.lodging.delete': "Eliminar habitación contratada",
    'permissions.item.lodging.hotel_config': "Editar configuración de hospedaje del hotel",
    'form.permissionPicker.adminFullAccess': 'El administrador del equipo tiene acceso total a todas las áreas del sistema.',
    'form.permissionPicker.loading': 'Cargando permisos…',
    'form.permissionPicker.loadFailed': 'No se pudieron cargar los permisos. Recargue la página.',
    'form.permissionPicker.doCargo': 'Del cargo',
    'form.permissionPicker.semArea': 'Marque el área {{areas}} para conceder estos permisos.',
    'form.permissionPicker.ouAreas': ' o ',
    'form.areaPicker.legenda': 'Áreas',
    'form.areaPicker.ajudaCargo': 'Todo usuario de este cargo entra en estas áreas. El área sola no abre ninguna pantalla: cada módulo sigue pidiendo su propio permiso.',
    'form.areaPicker.ajudaUsuario': 'Las áreas del cargo vienen marcadas y bloqueadas. Marque aquí solo las que este usuario recibe además del cargo.',
    'form.areaPicker.doCargo': 'Del cargo',
    'form.areaPicker.adminTodas': 'El administrador del equipo entra en todas las áreas.',
    'permissions.module.dashboard': 'Dashboard',
    'permissions.module.pendencias': 'Pendientes',
    'permissions.module.map': 'Mapa',
    'permissions.module.frota_leve_anomalias': 'Anomalía de flota',
    'permissions.module.contracts': 'Contratos',
    'permissions.module.unloading': 'Panel de Descarga',
    'permissions.module.shipments': 'Frente de Trabajo',
    'permissions.module.machine_transport': 'Transporte Máquina',
    'permissions.module.outros_servicos_transporte': 'Otros Servicios de Transporte',
    'permissions.module.sets': 'Conjuntos',
    'permissions.module.master_data': 'Registros',
    'permissions.module.imports': 'Importación masiva',
    'permissions.module.dp_ponto': 'Firma de la hoja de asistencia',
    'permissions.item.dp_ponto.view': 'Ver firmas de la hoja de asistencia',
    'permissions.item.dp_ponto.edit': 'Importar, marcar y cobrar firmas',
    'permissions.item.dp_ponto.fechar': 'Cerrar y reabrir el período',
    'permissions.module.dp_vale_alimentacao': 'Vale de alimentación',
    'permissions.item.dp_vale_alimentacao.view': 'Ver el vale de alimentación',
    'permissions.item.dp_vale_alimentacao.edit': 'Calcular y ajustar el vale de alimentación',
    'permissions.item.dp_vale_alimentacao.fechar': 'Cerrar y reabrir el período',
    'permissions.module.dp_ferias': 'Vacaciones',
    'permissions.item.dp_ferias.view': 'Ver vacaciones y programaciones',
    'permissions.item.dp_ferias.edit': 'Importar la programación y registrar gestiones',
    'permissions.module.dp_desligamento': 'Desvinculaciones',
    'permissions.item.dp_desligamento.view': 'Ver desvinculaciones',
    'permissions.item.dp_desligamento.edit': 'Abrir y conducir desvinculaciones',
    'permissions.module.dp_plano_saude': 'Plan de salud',
    'permissions.item.dp_plano_saude.view': 'Ver la factura del plan de salud',
    'permissions.item.dp_plano_saude.edit': 'Importar la factura y revisar titulares',
    'permissions.module.dp_exame': 'Exámenes',
    'permissions.item.dp_exame.view': 'Ver convocatorias de examen',
    'permissions.item.dp_exame.edit': 'Importar, agendar y registrar exámenes',
    'permissions.module.dp_cnh': 'Licencia de conducir',
    'permissions.item.dp_cnh.view': 'Ver vencimientos de licencia',
    'permissions.item.dp_cnh.edit': 'Actualizar vencimiento y cobrar',
    'permissions.module.dp_toxicologico': 'Toxicológico',
    'permissions.item.dp_toxicologico.view': 'Ver exámenes toxicológicos',
    'permissions.item.dp_toxicologico.edit': 'Registrar exámenes toxicológicos y adjuntar el informe',
    'permissions.module.dp_bonus': 'Bonos y adicionales',
    'permissions.item.dp_bonus.view': 'Ver bonos y adicionales',
    'permissions.item.dp_bonus.edit': 'Calcular bonos y mantener la tabla de valores',
    'permissions.item.dp_bonus.fechar': 'Cerrar y reabrir el período',
    'permissions.module.dp_contratacao': 'Contrataciones',
    'permissions.item.dp_contratacao.view': 'Ver vacantes abiertas',
    'permissions.item.dp_contratacao.edit': 'Abrir y conducir vacantes',
    'permissions.module.dp_rotina': 'Rutinas de nómina',
    'permissions.item.dp_rotina.view': 'Ver rutinas y checklist de nómina',
    'permissions.item.dp_rotina.edit': 'Marcar rutinas y verificaciones',
    'permissions.module.dp_multa': 'Multas',
    'permissions.item.dp_multa.view': 'Ver las multas registradas por Abastecimiento',
    'permissions.module.multa': 'Multas',
    'permissions.item.multa.view': 'Ver multas',
    'permissions.item.multa.create': 'Registrar multa',
    'permissions.item.multa.edit': 'Editar multa y adjuntos',
    'permissions.item.multa.cancel': 'Cancelar multa',
    // HubVerticalFarm (02/11/2026): um módulo por item do menu da Farm.
    'permissions.module.farm_inicio': 'Inicio de la Farm',
    'permissions.item.farm_inicio.view': 'Ver inicio de la Farm',
    'permissions.module.farm_mapa': 'Mapa de las haciendas',
    'permissions.item.farm_mapa.view': 'Ver mapa de las haciendas',
    'permissions.item.farm_mapa.manage': 'Gestionar mapa de las haciendas',
    'permissions.module.farm_agenda': 'Agenda de las haciendas',
    'permissions.item.farm_agenda.view': 'Ver agenda de las haciendas',
    'permissions.item.farm_agenda.manage': 'Gestionar agenda de las haciendas',
    'permissions.item.farm_agenda.pessoal': 'Ver y registrar las obligaciones personales',
    'permissions.module.farm_imoveis': 'Inmuebles',
    'permissions.item.farm_imoveis.view': 'Ver inmuebles',
    'permissions.item.farm_imoveis.manage': 'Gestionar inmuebles',
    'permissions.module.farm_documentos': 'Documentos de las haciendas',
    'permissions.item.farm_documentos.view': 'Ver documentos de las haciendas',
    'permissions.item.farm_documentos.manage': 'Gestionar documentos de las haciendas',
    'permissions.item.farm_documentos.historico': 'Borrar una versión antigua de documento',
    'permissions.module.farm_fundo': 'Fondo y arrendamientos',
    'permissions.item.farm_fundo.view': 'Ver fondo y arrendamientos',
    'permissions.item.farm_fundo.manage': 'Gestionar fondo y arrendamientos',
    'permissions.module.farm_lavoura': 'Cultivos',
    'permissions.item.farm_lavoura.view': 'Ver cultivos',
    'permissions.item.farm_lavoura.manage': 'Gestionar cultivos',
    'permissions.module.farm_confinamento': 'Engorde a corral',
    'permissions.item.farm_confinamento.view': 'Ver engorde a corral',
    'permissions.item.farm_confinamento.manage': 'Gestionar engorde a corral',
    'permissions.module.farm_floresta': 'Bosque y carbón',
    'permissions.item.farm_floresta.view': 'Ver bosque y carbón',
    'permissions.item.farm_floresta.manage': 'Gestionar bosque y carbón',
    'permissions.module.farm_equipe': 'Equipo de las haciendas',
    'permissions.item.farm_equipe.view': 'Ver equipo de las haciendas',
    'permissions.item.farm_equipe.manage': 'Vincular persona al inmueble',
    'permissions.module.farm_financeiro': 'Facturación y costos',
    'permissions.item.farm_financeiro.view': 'Ver facturación y costos',
    'permissions.item.farm_financeiro.importar': 'Enviar los archivos de Protheus',
    'permissions.module.farm_parceiros': 'Socios',
    'permissions.item.farm_parceiros.view': 'Ver socios',
    'permissions.item.farm_parceiros.manage': 'Gestionar socios',
    'permissions.module.farm_safras': 'Zafras y cultivos',
    'permissions.item.farm_safras.view': 'Ver zafras y cultivos',
    'permissions.item.farm_safras.manage': 'Gestionar zafras y cultivos',
    'permissions.module.farm_contatos': 'Contactos de las haciendas',
    'permissions.item.farm_contatos.view': 'Ver contactos de las haciendas',
    'permissions.item.farm_contatos.manage': 'Gestionar contactos de las haciendas',
    'permissions.module.dp_ausencia': 'Ausencias',
    'permissions.item.dp_ausencia.view': 'Ver ausencias, calendario y línea de tiempo',
    'permissions.item.dp_ausencia.edit': 'Registrar y cerrar ausencias',
    'permissions.module.dp_parametro': 'Parámetros de RR. HH.',
    'permissions.item.dp_parametro.view': 'Ver los parámetros de RR. HH.',
    'permissions.item.dp_parametro.edit': 'Cambiar los parámetros de RR. HH.',
    'permissions.module.dp_alerta': 'Destinatarios de alerta',
    'permissions.item.dp_alerta.view': 'Ver los grupos de destinatarios de alerta',
    'permissions.item.dp_alerta.edit': 'Armar los grupos y enviar el correo de prueba',
    'permissions.module.dp_colaborador': 'Historial del colaborador',
    'permissions.item.dp_colaborador.view': 'Ver el historial del colaborador',
    'permissions.module.dp_folha': 'Verificación de la nómina',
    'permissions.item.dp_folha.view': 'Ver la verificación de la nómina',
    'permissions.item.dp_folha.edit': 'Importar la nómina, ejecutar las reglas y justificar alertas',
    'permissions.item.dp_folha.fechar': 'Cerrar y reabrir la verificación',
    'permissions.module.dp_sinistro': 'Siniestros',
    'permissions.item.dp_sinistro.view': 'Ver los siniestros registrados por Abastecimiento',
    'permissions.module.sinistro': 'Siniestros',
    'permissions.item.sinistro.view': 'Ver siniestros',
    'permissions.item.sinistro.create': 'Registrar siniestro',
    'permissions.item.sinistro.edit': 'Editar siniestro y adjuntos',
    'permissions.item.sinistro.cancel': 'Cancelar siniestro',
    'permissions.module.dp_sensivel': 'Dato sensible del DP',
    'permissions.item.dp_sensivel.salario': 'Ver salario, valores de desvinculación y copago',
    'permissions.module.users': 'Usuarios',
    'permissions.module.audit': 'Auditoría',
    'permissions.item.dashboard.view': 'Ver dashboard',
    'permissions.item.pendencias.view': 'Ver pendientes',
    'permissions.item.map.view': 'Ver mapa',
    'permissions.item.map.interact': 'Interactuar con el mapa',
    'permissions.item.frota_leve_anomalias.view': 'Ver anomalía de la flota',
    'permissions.item.contracts.view': 'Ver contratos',
    'permissions.item.contracts.create': 'Crear contrato',
    'permissions.item.contracts.edit': 'Editar contrato',
    'permissions.item.contracts.delete': 'Eliminar contrato',
    'permissions.item.contracts.programar': 'Programar cargas',
    'permissions.item.contracts.programacao_ver': 'Ver la programación del cliente',
    'permissions.item.contracts.programacao_gerir': 'Gestionar la programación del cliente',
    'permissions.item.unloading.view': 'Ver panel de descarga',
    'permissions.item.unloading.tickets_manage': 'Gestionar solicitudes',
    'permissions.item.unloading.launch': 'Registrar descarga',
    'permissions.item.unloading.approve': 'Aprobar y cambiar estado',
    'permissions.item.shipments.view': 'Ver cargas',
    'permissions.item.shipments.create': 'Crear carga',
    'permissions.item.shipments.edit': 'Editar carga',
    'permissions.item.shipments.delete': 'Eliminar carga',
    'permissions.item.machine_transport.view': 'Ver',
    'permissions.item.machine_transport.create': 'Crear',
    'permissions.item.machine_transport.edit': 'Editar',
    'permissions.item.machine_transport.delete': 'Eliminar',
    'permissions.item.machine_transport.editar_datas': 'Corregir inicio y fin de la plataforma',
    'permissions.item.outros_servicos_transporte.view': 'Ver',
    'permissions.item.outros_servicos_transporte.create': 'Crear',
    'permissions.item.outros_servicos_transporte.edit': 'Editar',
    'permissions.item.outros_servicos_transporte.delete': 'Eliminar',
    'permissions.module.viagens': 'Viajes',
    'permissions.item.viagens.view': 'Ver viajes',
    'permissions.item.viagens.ajustar': 'Ajustar viaje y asignar servicio',
    'permissions.item.viagens.tratar_alerta': 'Tratar alerta de viaje',
    'permissions.item.viagens.cobranca': 'Marcar cobro y configurar límite de descarga',
    'permissions.module.pedagios': 'Peajes',
    'permissions.item.pedagios.view': 'Ver peajes',
    'permissions.item.pedagios.vincular': 'Vincular pasaje al viaje',
    'permissions.module.colheita': 'Cosecha',
    'permissions.item.colheita.view': 'Ver cosecha',
    'permissions.item.sets.view': 'Ver',
    'permissions.item.sets.create': 'Crear',
    'permissions.item.sets.edit': 'Editar',
    'permissions.item.sets.delete': 'Eliminar',
    'permissions.module.journey': 'Panel de Jornada',
    'permissions.item.journey.view': 'Ver panel de jornada',
    'permissions.item.journey.tratar': 'Justificar o clasificar infracción como gestión',
    'permissions.module.diaria': 'Panel de Viáticos',
    'permissions.item.diaria.view': 'Ver panel de viáticos',
    'permissions.item.diaria.edit': 'Registrar y corregir viático',
    'permissions.module.advertencia': 'Gestiones',
    'permissions.item.advertencia.view': 'Ver gestiones',
    'permissions.item.advertencia.gerar': 'Generar, aplicar y cancelar gestiones',
    'permissions.item.master_data.view': 'Ver registros',
    'permissions.item.master_data.create': 'Crear registro',
    'permissions.item.master_data.edit': 'Editar registro',
    'permissions.item.master_data.delete': 'Eliminar registro',
    'permissions.item.master_data.pii': 'Ver CPF y teléfono completos',
    'permissions.item.imports.view': 'Ver historial y plantillas',
    'permissions.item.imports.run': 'Validar e importar',
    'permissions.item.users.view': 'Ver usuarios',
    'permissions.item.users.manage': 'Gestionar usuarios y permisos',
    'permissions.item.audit.view': 'Consultar pista de auditoría',
    'permissions.item.audit.export': 'Exportar pista de auditoría',
    'permissions.module.assistente': 'Asistente',
    'permissions.item.assistente.usar': 'Conversar con el asistente',
  },
}
